import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';

import { withNoMessageToast as withoutToastNotification } from '../interceptors/http-toast.interceptor';
import { environment } from '../../../environments/environment';

export interface GetRoleDTO {
  total: number;
  data: Role[];
}

export interface Role {
  id: string;
  name: string;
}

export enum RoleType {
  Admin = 'Admin',
  Employee = 'Employee',
  Client = 'Client',
}

@Injectable({ providedIn: 'root' })
export class RoleService {
  private rolesSubject = new BehaviorSubject<Role[]>([]);
  roles$ = this.rolesSubject.asObservable();
  private http = inject(HttpClient);
  RoleType: any;

  getRoles(): Observable<GetRoleDTO> {
    return this.http
      .get<GetRoleDTO>(environment.baseApiUrl + '/api/roles', {
        context: withoutToastNotification(),
      })
      .pipe(
        tap((response) => {
          this.rolesSubject.next(response.data);
        })
      );
  }

  getRoleByName(name: RoleType): Role | undefined {
    return this.rolesSubject.value.find((role) => role.name === name);
  }
}
